import "./App.css";
import { useEffect, Suspense, lazy } from "react";
import Aos from "aos";
import "aos/dist/aos.css";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";

import { Loader } from "@classplus-engineering/components";

import Navbar from "./components/Navbar/Navbar";
import LandingPage from "./pages/LandingPage/LandingPage";
// import OpenRole from "./pages/OpenRole/OpenRole";
import Footer from "./components/Footer/Footer";
import FormDetail from "./components/FormDetail/FormDetail";
// import JobDescription from "./pages/JobDescription";

const OpenRole = lazy(() => import("./pages/OpenRole/OpenRole"));
const JobDescription = lazy(() => import("./pages/JobDescription"));

function App() {
	useEffect(() => {
		Aos.init({ duration: 600 });
	}, []);

	const loadingStyle = {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		position: "absolute",
		top: "50%",
		left: "50%",
		transform: "translate(-50%,-50%)",
		// marginTop: "40%",
	};

	return (
		<div style={{ overflowX: "hidden" }}>
			<BrowserRouter basename='/careers'>
				<Suspense
					fallback={<Loader style={{ ...loadingStyle }} size='Large' />}
				>
					<Navbar />
					<Switch>
						<Route exact component={LandingPage} path='/' />
						<Route exact component={OpenRole} path='/open-role' />
						<Route exact component={JobDescription} path='/job-description' />
						<Route exact component={FormDetail} path='/apply' />
						<Redirect from='*' to='/' />
					</Switch>
				</Suspense>
				<Footer />
			</BrowserRouter>
		</div>
	);
}

export default App;
